import { IntegrationScript } from "../lib/IntegrationScript"

const src = "https://embed.typeform.com/next/embed.js"

export const TypeformTag = () => {
  return <IntegrationScript id="typeform" onlyWhenNeeded src={src} />
}
